import { render, staticRenderFns } from "./couponSetting.vue?vue&type=template&id=6f238f58&scoped=true&"
import script from "./couponSetting.vue?vue&type=script&lang=ts&"
export * from "./couponSetting.vue?vue&type=script&lang=ts&"
import style0 from "./couponSetting.vue?vue&type=style&index=0&id=6f238f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f238f58",
  null
  
)

component.options.__file = "couponSetting.vue"
export default component.exports